module.exports = __webpack_public_path__ + "media/images/flags/dk-99cbc127cd4d9e3184a47a60be478365.svg";